module.exports = __webpack_public_path__ + "img/118-malasya.ca02fb59.svg";